import _ from 'lodash';
import { ReactJsonView } from 'react-scale/corp/components/ReactJsonView';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LintRule } from '@scale/shared/types/linter';
import SelectProjectHeader from 'corp/components/Projects/SelectProjectHeader';
import { IProjectJson } from '@scale/shared/types/project';

const ResponseLintersInfo = ({
  rules,
  validationErrors,
  selectedProject,
  onSelectProject,
}: {
  rules?: LintRule<any>[];
  validationErrors: string[];
  selectedProject: IProjectJson;
  onSelectProject: (item?: { value: string }) => void;
}) => {
  return (
    <div style={{ maxWidth: '95%' }}>
      <h2>Response Linters Info</h2>
      <SelectProjectHeader selectedProject={selectedProject} onSelectProject={onSelectProject} />

      {rules !== undefined && <LintersInfo rules={rules} validationErrors={validationErrors} />}
    </div>
  );
};

const LintersInfo = ({
  rules,
  validationErrors,
}: {
  rules: LintRule<any>[];
  validationErrors: string[];
}) => {
  if (!rules.length) {
    return (
      <div>
        <h2>No Linters Rules configured for this project</h2>
        {getLintersDocsLink()}
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="lint">
        {getLintersDocsLink()}
        <div className="header">
          <h3>Linter rules</h3>
        </div>
        {rules.map((rule, ix) => (
          <div key={ix} style={{ marginBottom: '10px' }}>
            {rule.name}:{' '}
            <a
              href={`https://dashboard.scale.com/corp/linter_config_docs#${rule.condition.scriptName}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {rule.condition.scriptName}
            </a>
          </div>
        ))}
        <ReactJsonView
          src={rules}
          name={false}
          theme="monokai"
          iconStyle="triangle"
          collapsed={4}
          collapseStringsAfterLength={120}
          groupArraysAfterLength={false}
          displayObjectSize={false}
          displayDataTypes={false}
        />

        {validationErrors.length > 0 && (
          <div className="validationErrors">
            <h4>
              <FontAwesomeIcon icon="exclamation-triangle" color="rgba(255, 202, 40, 1)" /> Rule
              Errors Detected{' '}
              <FontAwesomeIcon icon="exclamation-triangle" color="rgba(255, 202, 40, 1)" />
            </h4>
            <ul>
              {_.map(validationErrors, (error, idx) => (
                <li key={idx}>{error}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <style jsx>{`
        .lint {
          padding: 10px 0;
          animation: fadein 200ms;
          animation-delay: 50ms;
        }

        .lint .container {
          padding: 12px;
          width: 300px;
        }

        .lint .header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 12px;
          margin-top: 20px;
        }

        .hint {
          opacity: 0.6;
        }

        @keyframes fadein {
          from {
            opacity: 0.5;
            transform: translateX(100px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
      `}</style>
    </React.Fragment>
  );
};

const getLintersDocsLink = () => {
  return (
    <div>
      Refer to the{' '}
      <a
        href="https://dashboard.scale.com/corp/linter_config_docs"
        target="_blank"
        rel="noopener noreferrer"
      >
        documentation
      </a>{' '}
      to learn more about available linters and how to configure them.
    </div>
  );
};

export default ResponseLintersInfo;
